import { TenantFeatures } from './tenant-config.model';

// Maps route.config.ts translate keys to the tenant feature flag that must
// be on for the entry to be selectable. Applied on top of whatever the
// existing role/progression logic already computed for `isAvailable`, so a
// tenant can only ever narrow visibility, never widen it.
const ROUTE_FEATURE_BY_TRANSLATE: { [translate: string]: keyof TenantFeatures } = {
  'MENU.TEST': 'testing',
};

export function gateRoutesByTenant(routes: any[], features: TenantFeatures): any[] {
  routes.forEach((route) => {
    const featureKey = ROUTE_FEATURE_BY_TRANSLATE[route.translate];
    if (featureKey && !features[featureKey]) {
      route.isAvailable = false;
    }
  });
  return routes;
}
